import React from 'react';

const TicketHeader = ({ ticket }) => {
  return (
    <div className="mb-6 pb-6 border-b-2 border-blue-500/10 bg-gradient-to-br from-slate-50 to-slate-100 -mx-6 -mt-6 px-6 pt-8 rounded-t-xl">
      <h2 className="text-slate-900 font-bold mb-4 font-poppins text-center tracking-tight text-2xl">
        📋 Ticket Details
      </h2>
      <div className="max-w-sm mx-auto p-4 bg-white rounded-lg border-2 border-blue-600 shadow-lg text-center">
        <p className="font-poppins font-medium text-xs uppercase tracking-wider mb-2 text-slate-600">
          Tracking ID
        </p>
        <p className="font-bold text-blue-600 font-poppins tracking-wide text-xl">
          {ticket.trackingId}
        </p>
      </div>
    </div>
  );
};

export default TicketHeader;